<template lang="pug">
  .login-view
    .login-view-container
      .h-100.row.align-items-center
        login.col-sm-12.col-md-4
</template>

<script>
import Login from '../components/auth/Login'

export default {
  components: {
    Login
  }
}
</script>

<style lang="scss" scoped>
@import '../style/colors.scss';
.login-view {
  padding: 1rem;
  height: 100%;
  background-color: var(--primary);
  &-container {
    height: 100%;
  }
}
.login {
  margin: auto;
}
</style>
